<div class="page-header">
  <div class="container pt-1 pb-1 external-user">
    <div class="page-title">
      <h1 class="m-0">{{ pageTitle }}</h1>
    </div>
  </div>
</div>

<div class="workflow-bar margin30Top">
  <div class="container external-user" [hidden]="isReturnRate || !currentNavOrder">
    <tql-workflow-bar 
      [workflowRoutes]="navRoutes" 
      [currentNavOrder]="currentNavOrder"
      [statusTypeId]="1"
      (stepClick)="navigateToRoute($event)">
    </tql-workflow-bar>
  </div>
</div>

<div class="assistance-shipping-rules margin30Top margin30Bottom">
  <div class="container d-flex justify-content-between external-user">
    <div class="instuctional-text">
      {{ ftlAssistanceMessage }} <span *ngIf="primaryBroker && primaryBroker.primaryPhoneExtension">ext. {{ primaryBroker.primaryPhoneExtension }}</span>
    </div>
    <div class="shipping-rules">
    </div>
  </div>
</div>

<div class="container external-user">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div>

<div id="spinner-overlay" class="spinner-overlay external-user" *ngIf="asyncCallInProgress">
  <div class="loader"></div>
</div>
